import React, { useState } from 'react';
import '../Notation.css';

const tracks = [
  { title: 'Shape of You', artist: 'Ed Sheeran' },
  { title: 'Blinding Lights', artist: 'The Weeknd' },
  { title: 'Levitating', artist: 'Dua Lipa' },
  { title: 'Bad Guy', artist: 'Billie Eilish' },
];

export default function Notation() {
  const [ratings, setRatings] = useState<number[]>([0, 0, 0, 0]);
  const setRating = (i: number, r: number) => {
    setRatings(arr => arr.map((v, idx) => idx === i ? r : v));
  };
  return (
    <div className="notation-root">
      <h1>Noter les morceaux</h1>
      <div className="notation-list">
        {tracks.map((t, i) => (
          <div className="notation-item" key={i}>
            <div className="notation-title">
              <strong>{t.title}</strong> <span>- {t.artist}</span>
            </div>
            <div className="notation-stars">
              {[1,2,3,4,5].map(star => (
                <span
                  key={star}
                  className={star <= ratings[i] ? 'star active' : 'star'}
                  onClick={() => setRating(i, star)}
                  role="button"
                  aria-label={`Noter ${star} sur 5`}
                >★</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 